<div class="container">
  <mat-card>
    <form [formGroup]="clientSavingsAccountForm" (ngSubmit)="submit()">
      <mat-card-content>
        <div class="layout-column">
          <mat-form-field class="flex-48">
            <mat-label>{{ 'labels.inputs.Default Savings Account' | translate }}</mat-label>
            <mat-select formControlName="savingsAccountId">
              @for (account of savingsAccounts; track account) {
                <mat-option [value]="account.id">
                  {{ account.accountNo }}
                </mat-option>
              }
            </mat-select>
            @if (clientSavingsAccountForm.controls.savingsAccountId.hasError('required')) {
              <mat-error>
                {{ 'labels.inputs.Account' | translate }} {{ 'labels.commons.is' | translate }}
                <strong>{{ 'labels.commons.required' | translate }}</strong>
              </mat-error>
            }
          </mat-form-field>
        </div>
      </mat-card-content>

      <mat-card-actions class="layout-row align-center gap-5px responsive-column">
        <button type="button" mat-raised-button [routerLink]="['../../']">
          {{ 'labels.buttons.Cancel' | translate }}
        </button>
        <button mat-raised-button color="primary" [disabled]="!clientSavingsAccountForm.valid">
          {{ 'labels.buttons.Confirm' | translate }}
        </button>
      </mat-card-actions>
    </form>
  </mat-card>
</div>
